module.exports = __webpack_public_path__ + "img/back exposed zipper length.562ed1c1.png";